import React, { PureComponent } from "react"
import qs from 'querystring';
// import { Link } from "gatsby"
// import Row from "react-bootstrap/Row"
// import Col from "react-bootstrap/Col"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import TabContainer from "../components/tab-container"

import bannerPng from "../images/business/banner.png"
import regionPng from "../images/business/map.png"
import partnerGNTPng from "../images/business/partner-gnt.png"
import partnerHXGKPng from "../images/business/partner-hxgk.png"
import partnerHXKJPng from "../images/business/partner-hxkj.png"
import partnerHXZSPng from "../images/business/partner-hxzs.png"
import partnerSMFPng from "../images/business/partner-smf.png"

import productDNA from "../images/business/product-dna.png"
import productDNADetail from "../images/business/product-dna-detail.png"

// import productY from "../images/business/product-y.png"
// import productYDetail from "../images/business/product-y-detail.png"

import productLims from "../images/business/product-lims.png"
import productLimsDetail from "../images/business/product-lims-detail.png"

// import productYPad from "../images/business/product-y-pad.png"
// import productYPadDetail from "../images/business/product-y-pad-detail.png"

import './business.css';

const tabList = ["产品介绍", "合作伙伴"]

const productList = [{
    imgSrc: productDNA,
    detailImgSrc: productDNADetail,
    title: 'DNA建库采集终端',
    desc: 'DNA建库采集终端是根据刑事技术技术各级采集单位、各级受理单位的业务流程研发设计。系统覆盖DNA数据建库登记、建库查重、建库受理、建库统计、建库统一管理。系统满足批量化建库查重需要，大幅提高建库工作的效率，降低DNA数据的重复建库率。'
  },
  // {
  //   imgSrc: productY,
  //   detailImgSrc: productYDetail,
  //   title: '全国公安机关男性家族排查系统',
  //   desc: '全国公安机关男性家族排查系统是在常染色体STR数据库的基上对Y染色体基因型信息建库，用以实现信息储存、查询比对、信息共享的数据库系统。通过Y-STR库的建设，能够更加有效的发挥DNA技术的威力，成为常染色体STR库的有益补充，尤其在圈定侦查范围、亲子鉴定中的父权鉴定发挥重要作用。'
  // },
  {
    imgSrc: productLims,
    detailImgSrc: productLimsDetail,
    title: 'DNA实验室专家辅助分析与管理系统',
    desc: 'DNA实验室专家辅助分析与管理系统（DNA_LIMS）依靠实验室内部网络和DNA实验室信息数据库将DNA实验室中的遗传分析仪、实验室自动化平等仪器设备连接起来，为各类样品采集、送检和受理提供工作平台，也是DNA实验室的软件工程做平台，既能满足日常检验、数据分析和技术管理要求，又能保证DNA数据库建设的严格管理、控制。'
    },
  // {
  //   imgSrc: productYPad,
  //   detailImgSrc: productYPadDetail,
  //   title: '全国公安机关男性家族排查系统家系采集用户端',
  //   desc: '全国公安机关男性家族排查系统家系采集用户端是根据刑事技术各级家系采集建库单位的业务流程研发设计。系统覆盖了YSTR家系新建、家系图谱绘制、家系查询、快速身份信息录入、家系数据导出。系统可进行定向 的批量化家系区域采集，根据样本间的父系血缘关系自动生成家系图谱。'
  // }
];

class Page extends PureComponent {
  state = {
    activeIndex: 0,
  }

  onProductClick = index => {
    this.setState({ activeIndex: index })
  }

  componentDidMount () {
    const { search } = this.props.location;
    const newSearch = search.split('?')
    const params = qs.parse(newSearch[1]);
    const { product } = params;
    const productIndex = parseInt(product, 10);
    if (product) {
      this.setState({ activeIndex: productIndex })
    }
  }

  render() {
    const { activeIndex } = this.state;

    const products =  productList.map((it, index) => {
      const { imgSrc, title } = it;
      const className = activeIndex === index ? 'productImg productActive' : 'productImg';
      return(
        <div className="productItem" key={index}>
          <img
            onClick={() => this.onProductClick(index)}
            src={imgSrc}
            className={className}
            alt={title}
          />
        </div>
      )
    });

    const productDetails = productList.map((it, index) => {
      const { imgSrc, detailImgSrc, title, desc } = it;
      return(
        <div key={index} style={{ display: activeIndex === index ? "block" : "none" }}>
          <div className="detailItem">
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div className="detailImgWrap">
                <img className="detailImg" src={imgSrc} alt={title}/>
              </div>
              <div className="detailImgWrap">
                <img className="detailImg" src={detailImgSrc} alt={title} />
              </div>
            </div>
            <div className="detailInfo">
              <h5 className="detailTitle">{title}</h5>
              <p className="detailDesc">{desc}</p>
            </div>
          </div>
        </div>
      );
    });

    return(
      <Layout>
        <SEO title="业务体系" />
        <Banner image={bannerPng} />
        <Section>
          <TabContainer
            tabList={tabList}
            style={{ paddingTop: 30 }}
          >
            <div>
              <div className="detailWrap">
                {productDetails}
              </div>
              <div className="productWrap">
                {products}
              </div>
            </div>
            <div className="partner">
              <ul className="serverWrap">
                <li>我们的客户</li>
                <img src={regionPng} alt="服务区域" />
                <p className="serverText">海华鑫安产品、方案已经广泛应用于国内30余个省/自治区/直辖市，<br/>服务体系覆盖全国三十多个省/自治区/直辖市</p>
              </ul>
              <ul>
                <li>战略合作伙伴</li>
                <div className="partnerWrap">
                  <img src={partnerGNTPng} alt="广州市高奈特网络科技有限公司" />
                  <img src={partnerHXGKPng} alt="北京海鑫高科指纹技术有限公司" />
                  <img src={partnerHXKJPng} alt="北京海鑫科金高科技股份有限公司" />
                  <img src={partnerHXZSPng} alt="北京海鑫智圣技术有限公司" />
                  <img src={partnerSMFPng} alt="赛默飞世尔" />
                </div>
              </ul>
            </div>
          </TabContainer>
        </Section>
      </Layout>
    )
  }
}

export default Page
